var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c("div", { staticClass: "login-weaper animated bounceInDown" }, [
        _vm._m(0),
        _c("p", { staticClass: "login-tip" }, [
          _vm._v(_vm._s(_vm.website.title)),
        ]),
        _c("div", { staticClass: "login-border" }, [
          _c(
            "div",
            { staticClass: "login-main" },
            [
              _vm.activeName === "user"
                ? _c("userLogin", { on: { change: _vm.updateActiveName } })
                : _vm.activeName === "code"
                ? _c("codeLogin")
                : _vm.activeName === "third"
                ? _c("thirdLogin")
                : _vm.activeName === "register"
                ? _c("user-register", { on: { change: _vm.updateActiveName } })
                : _vm.activeName === "forgetPwd"
                ? _c("forgot-password", {
                    on: { change: _vm.updateActiveName },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c("top-color", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-logo" }, [
      _c("img", {
        attrs: { src: require("../../../public/img/logo.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }